<template>
  <div class="col-md-8">
    <div class="form-group">
      <div my-15px>
        <label class="mx-5">
          <h4>
            Custom Text
          </h4>
        </label>

        <div class="form-group">
          <ckeditor
            @blur="submit"
            :read-only="disabled"
            v-model="custom_text"
            :config="{
              extraPlugins: 'colorbutton',
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { leaderBoardService } from "@/api/client";

export default {
  name: "CustomText",

  props: ["campaign"],

  data() {
    return {
      custom_text: "",
    };
  },

  computed: {
    disabled() {
      return this.campaign.status != "draft";
    },

    formData() {
      return {
        custom_text: this.custom_text,
      };
    },
  },

  methods: {
    async submit() {
      if (!this.campaign.custom_text && !this.custom_text) return;

      if (
        this.isString(this.campaign.custom_text) &&
        this.isString(this.custom_text) &&
        this.campaign.custom_text.substr(0, 100) ==
          this.custom_text.substr(0, 100)
      ) {
        return;
      }

      try {
        const { id } = this.campaign;
        const form = this.formData;

        await leaderBoardService.updateCampaign(id, form);

        this.$emit("updated");
        this.$notify(`Custom text updated.`);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Update custom text error.`);
      }
    },

    isString(myVar) {
      return typeof myVar === "string" || myVar instanceof String;
    },
  },

  mounted() {
    this.custom_text = this.campaign.custom_text;
  },
};
</script>

<style lang="scss" scoped>
.light {
  color: gray;
  font-weight: 300;
}

.wrapper-image-preview {
  text-align: center;
  min-height: 300px;
  background-color: #efefef;
}

.image-preview {
  padding: 12px;
  min-height: 300px;
  background-color: #eaeaea;
}

.image-preview,
input[type="file"] {
  min-width: 420px;
}
</style>
